import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {LanguageListStore} from '../LanguageListStore';

@observer
export class AddLanguageControls extends React.Component<{ store: LanguageListStore }> {
  render() {
    const {store} = this.props;

    if (store.addLanguage === null)
      return null;

    const addLanguage = store.addLanguage;
    const isPending = addLanguage.save?.isPending === true;

    return (<>
      <div className="row justify-content-end">
        <div className="col-auto">
          <button type="button" className="btn btn-primary"
                  onClick={store.completeAdd}
                  disabled={isPending}>
            Save
          </button>
          <button type="button" className="btn btn-primary"
                  onClick={store.cancel}
                  disabled={isPending}>
            Cancel
          </button>
        </div>
      </div>

      <PromiseMessage label="Saving" state={addLanguage.save} align="right"/>
    </>);
  }
}
